import * as MD from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { Route, RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { IApplicationState, IConnectedReduxProps } from '../../Store';
import { I18N } from '../../Store/I18n/Types';
import { IUserState } from '../../Store/User/Types';
import { IUserManagementState } from '../../Store/UserManagement/Types';
import { isNullOrUndefined } from '../../Utils/Various';
import { UsersAndGroupsFromChannel } from './AppsManagementTabsContent/Mediaarchiver/Global/ChannelUsersAndGroups';
import { AllChannels } from './AppsManagementTabsContent/AllChannels';
import { GroupOrUserChannels } from './AppsManagementTabsContent/Mediaarchiver/Global/GroupOrUserChannels';
import { UsersAndGroupsFromChannel as UsersAndGroupsFromChannelTPP } from './AppsManagementTabsContent/Mediaarchiver/TPP/ChannelUsersAndGroups';
import { GroupOrUserChannels as GroupOrUserChannelsTPP } from './AppsManagementTabsContent/Mediaarchiver/TPP/GroupOrUserChannels';
import { UsersAndGroupsFromChannel as UsersAndGroupsFromChannelSTT } from './AppsManagementTabsContent/Mediaarchiver/STT/ChannelUsersAndGroups';
import { GroupOrUserChannels as GroupOrUserChannelsSTT } from './AppsManagementTabsContent/Mediaarchiver/STT/GroupOrUserChannels';
import { GroupsFromChannel as GroupsFromChannelMT } from './AppsManagementTabsContent/MyTrack/ChannelGroups';
import { GroupChannels as GroupChannelsMT } from './AppsManagementTabsContent/MyTrack/GroupChannels';

export interface IRouterMatchParams {
	groupName: string;
	type: string;
}

interface IPropsFromState {
	i18n: I18N;
	router: RouteComponentProps<IRouterMatchParams>;
	user: IUserState;
	userManagement: IUserManagementState;
}

interface IPropsFromDispatch {}

type AllProps = IPropsFromState &
	IPropsFromDispatch &
	RouteComponentProps<{}> &
	IConnectedReduxProps;

export class AppsManagementContentComponent extends React.Component<AllProps> {
	public constructor(props: AllProps) {
		super(props);
	}

	public render(): React.ReactNode {
		switch (this.props.router.match.params.type) {
			case 'mediaarchiver':
				return (
					<React.Fragment>
						{this.renderMediaarchiver()}
					</React.Fragment>
				);
			case 'mediaarchiver-user':
				return (
					<React.Fragment>
						{this.renderMediaarchiverUser()}
					</React.Fragment>
				);
			case 'mediaarchiver-group':
				return (
					<React.Fragment>
						{this.renderMediaarchiverUser()}
					</React.Fragment>
				);

			case 'mediaarchiver-tpp':
				return (
					<React.Fragment>
						{this.renderMediaarchiverTPP()}
					</React.Fragment>
				);
			case 'mediaarchiver-tpp-user':
				return (
					<React.Fragment>
						{this.renderMediaarchiverTPPUser()}
					</React.Fragment>
				);
			case 'mediaarchiver-tpp-group':
				return (
					<React.Fragment>
						{this.renderMediaarchiverTPPUser()}
					</React.Fragment>
				);
			case 'mediaarchiver-stt':
				return (
					<React.Fragment>
						{this.renderMediaarchiverSTT()}
					</React.Fragment>
				);
			case 'mediaarchiver-stt-user':
				return (
					<React.Fragment>
						{this.renderMediaarchiverSTTUser()}
					</React.Fragment>
				);
			case 'mediaarchiver-stt-group':
				return (
					<React.Fragment>
						{this.renderMediaarchiverSTTUser()}
					</React.Fragment>
				);
			case 'mytrack':
				return <React.Fragment>{this.renderMytrack()}</React.Fragment>;
			case 'mytrack-group':
				return (
					<React.Fragment>{this.renderMytrackUser()}</React.Fragment>
				);
			default:
				return (
					<React.Fragment>
						{this.renderMediaarchiver()}
					</React.Fragment>
				);
		}
	}

	private renderMediaarchiver(): React.ReactNode {
		let mode = 0;
		if (isNullOrUndefined(this.props.router.match.params.groupName)) {
			mode = 0;
		} else {
			if (
				!isNaN(parseInt(this.props.router.match.params.groupName, 10))
			) {
				mode = 1;
			} else {
				mode = 0;
			}
		}
		return (
			<React.Fragment>
				<MD.Tabs
					onChange={this.handleTabs.bind(this)}
					value={mode}
					indicatorColor="primary"
					textColor="primary"
				>
					<MD.Tab label={this.props.i18n._('Global view')} />
					{mode === 1 ? (
						<MD.Tab
							label={this.props.i18n._(
								'view of media #' +
									parseInt(
										this.props.router.match.params
											.groupName,
										10
									)
							)}
						/>
					) : (
						''
					)}
				</MD.Tabs>
				<this.TabPanel value={mode} index={0}>
					<Route component={AllChannels} />
				</this.TabPanel>
				<this.TabPanel value={mode} index={1}>
					<Route component={UsersAndGroupsFromChannel} />
				</this.TabPanel>
			</React.Fragment>
		);
	}

	private renderMediaarchiverUser(): React.ReactNode {
		return <Route component={GroupOrUserChannels} />;
	}
	private renderMediaarchiverTPP(): React.ReactNode {
		let mode = 0;
		if (isNullOrUndefined(this.props.router.match.params.groupName)) {
			mode = 0;
		} else {
			if (
				!isNaN(parseInt(this.props.router.match.params.groupName, 10))
			) {
				mode = 1;
			} else {
				mode = 0;
			}
		}
		return (
			<React.Fragment>
				<MD.Tabs
					onChange={this.handleTabs.bind(this)}
					value={mode}
					indicatorColor="primary"
					textColor="primary"
				>
					<MD.Tab label={this.props.i18n._('Global view')} />
					{mode === 1 ? (
						<MD.Tab
							label={this.props.i18n._(
								'view of media #' +
									parseInt(
										this.props.router.match.params
											.groupName,
										10
									)
							)}
						/>
					) : (
						''
					)}
				</MD.Tabs>
				<this.TabPanel value={mode} index={0}>
					<Route component={AllChannels} />
				</this.TabPanel>
				<this.TabPanel value={mode} index={1}>
					<Route component={UsersAndGroupsFromChannelTPP} />
				</this.TabPanel>
			</React.Fragment>
		);
	}
	private renderMediaarchiverSTT(): React.ReactNode {
		let mode = 0;
		if (isNullOrUndefined(this.props.router.match.params.groupName)) {
			mode = 0;
		} else {
			if (
				!isNaN(parseInt(this.props.router.match.params.groupName, 10))
			) {
				mode = 1;
			} else {
				mode = 0;
			}
		}
		return (
			<React.Fragment>
				<MD.Tabs
					onChange={this.handleTabs.bind(this)}
					value={mode}
					indicatorColor="primary"
					textColor="primary"
				>
					<MD.Tab label={this.props.i18n._('Global view')} />
					{mode === 1 ? (
						<MD.Tab
							label={this.props.i18n._(
								'view of media #' +
									parseInt(
										this.props.router.match.params
											.groupName,
										10
									)
							)}
						/>
					) : (
						''
					)}
				</MD.Tabs>
				<this.TabPanel value={mode} index={0}>
					<Route component={AllChannels} />
				</this.TabPanel>
				<this.TabPanel value={mode} index={1}>
					<Route component={UsersAndGroupsFromChannelSTT} />
				</this.TabPanel>
			</React.Fragment>
		);
	}
	private renderMytrack(): React.ReactNode {
		let mode = 0;
		if (isNullOrUndefined(this.props.router.match.params.groupName)) {
			mode = 0;
		} else {
			if (
				!isNaN(parseInt(this.props.router.match.params.groupName, 10))
			) {
				mode = 1;
			} else {
				mode = 0;
			}
		}
		return (
			<React.Fragment>
				<MD.Tabs
					onChange={this.handleTabs.bind(this)}
					value={mode}
					indicatorColor="primary"
					textColor="primary"
				>
					<MD.Tab label={this.props.i18n._('Global view')} />
					{mode === 1 ? (
						<MD.Tab
							label={this.props.i18n._(
								'view of media #' +
									parseInt(
										this.props.router.match.params
											.groupName,
										10
									)
							)}
						/>
					) : (
						''
					)}
				</MD.Tabs>
				<this.TabPanel value={mode} index={0}>
					<Route component={AllChannels} />
				</this.TabPanel>
				<this.TabPanel value={mode} index={1}>
					<Route component={GroupsFromChannelMT} />
				</this.TabPanel>
			</React.Fragment>
		);
	}

	private renderMediaarchiverTPPUser(): React.ReactNode {
		return <Route component={GroupOrUserChannelsTPP} />;
	}
	private renderMediaarchiverSTTUser(): React.ReactNode {
		return <Route component={GroupOrUserChannelsSTT} />;
	}
	private renderMytrackUser(): React.ReactNode {
		return <Route component={GroupChannelsMT} />;
	}

	private TabPanel(props: any): JSX.Element {
		const { children, value, index } = props;
		return <div>{value === index && <div>{children}</div>}</div>;
	}

	private handleTabs(e: React.ChangeEvent<{}>, val: number) {
		switch (val.toString(10)) {
			case '0':
				this.props.router.history.push(`/apps/mediaarchiver`);
				break;
			default:
				this.props.router.history.push(`/apps/mediaarchiver`);
		}
	}
}

const mapStateToProps = (
	{ i18n, user, userManagement }: IApplicationState,
	ownProps: RouteComponentProps<IRouterMatchParams>
) => ({
	i18n: i18n.i18n,
	router: ownProps,
	user,
	userManagement,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

export const AppsManagementContent = connect(
	mapStateToProps,
	mapDispatchToProps
)(AppsManagementContentComponent);
